import { render } from "./FullScreenLoading.vue?vue&type=template&id=1704efaa&scoped=true&ts=true"
import script from "./FullScreenLoading.vue?vue&type=script&lang=ts"
export * from "./FullScreenLoading.vue?vue&type=script&lang=ts"

import "./FullScreenLoading.vue?vue&type=style&index=0&id=1704efaa&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1704efaa"]])

export default __exports__